// File: frontend/src/config/katifiAccess.js
// Version: 1.0 (quick-260909-qa3)
// Date: 2026-09-09
// Назначение: ЕДИНСТВЕННЫЙ держатель правила видимости виджета Katifi/Julifi и
//             его имени.
//
// 🔴 Выражения перенесены из KatifiWidget.js:123-139 и :172-173 ДОСЛОВНО, буква
//    в букву. Копия завела бы ВТОРОЕ мнение о том, кому виден виджет: кнопка
//    «Спросить …» в верхней полосе показалась бы тому, у кого виджета нет, и
//    вела бы в никуда. То же основание, что у navPermissions.js для меню.
//
// 🔴 Модуль ЧИСТЫЙ (ни одного импорта) — его можно ИСПОЛНИТЬ и сверить с
//    замороженным телом прежнего выражения на матрице синтетических
//    пользователей. Правило, которое нельзя исполнить, проверяется только
//    грепом, а греп не отвечает на вопрос «кому именно видно».

// Перенесено из KatifiWidget.js:123-124 без изменений.
export const roleNamesOf = (user) => {
    const userRoles = Array.isArray(user?.roles) ? user.roles : [];
    return userRoles.map(r => typeof r === 'string' ? r.toUpperCase() : (r.name || '').toUpperCase());
};

// KatifiWidget.js:126
export const isCreator = (user) => {
    const roleNames = roleNamesOf(user);
    return user?.email === 'afitbk@gmail.com' || roleNames.includes('ADMINISTRATOR') || roleNames.includes('ADMIN');
};

// KatifiWidget.js:127
export const hasPermission = (user) => user?.allowed_tabs?.['katifi_assistant'] === true;

// KatifiWidget.js:128
export const isSuperUser = (user) => roleNamesOf(user).includes('ADMINISTRATOR');

// KatifiWidget.js:132 — на арендаторе fitenko владелица фирмы считается
// пользователем Katifi, а не Julifi. Тот же рубеж есть на бэкенде
// (admin/katifi/chat.py, ключ settings.INSTANCE_NAME=='fitenko').
export const isTenantOwner = (user) => user?.email === 'fitenkolaw@gmail.com' && roleNamesOf(user).includes('MANAGING_PARTNER');

// KatifiWidget.js:136 — управляет ЛИЧНОСТЬЮ (имя/титул/аватар) и выбором
// эндпоинта между /admin/katifi/* и /admin/julifi/*.
export const canUseKatifi = (user) => isCreator(user) || isTenantOwner(user);

// KatifiWidget.js:139 — ВИДИМОСТЬ виджета. Ровно это же правило решает,
// показывать ли кнопку «Спросить …» в верхней полосе.
export const canSeeKatifi = (user) => isCreator(user) || hasPermission(user) || isSuperUser(user) || isTenantOwner(user);

// KatifiWidget.js:172-173
export const aiName = (user) => canUseKatifi(user) ? 'Katifi AI' : 'Julifi AI';
export const aiTitle = (user) => canUseKatifi(user) ? 'System Intelligence' : 'Personal Assistant';
